import { render, staticRenderFns } from "./DistributionContainerConfig.vue?vue&type=template&id=06431411"
import script from "./DistributionContainerConfig.vue?vue&type=script&lang=js"
export * from "./DistributionContainerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports